// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileCommsTable_root__367HM"};